module.exports = __webpack_public_path__ + "img/nhm_white_text.8b1b4d33.png";